export const OPENED_DEFAULT_FAQ_ARTICLE = "OPENED_DEFAULT_FAQ_ARTICLE";
export const WROTE_QUESTION = "WROTE_QUESTION";
export const RECEIVED_RETRIEVED_FAQ_ARTICLE = "RECEIVED_RETRIEVED_FAQ_ARTICLE";
export const OPENED_RETRIEVED_FAQ_ARTICLE = "OPENED_RETRIEVED_FAQ_ARTICLE";
export const CLICKED_CREATE_SUPPORT_CASE = "CLICKED_CREATE_SUPPORT_CASE";
export const OPENED_CLOSE_CONFIRMATION = "OPENED_CLOSE_CONFIRMATION";
export const CLOSED_DIALOG = "CLOSED_DIALOG";
export const SENT_SUPPORT_CASE = "SENT_SUPPORT_CASE";
export const RESET_FAQ_DIAGNOSTICS = "RESET_FAQ_DIAGNOSTICS";
